import fcl from "../config.js";


export async function getPublicAccount(address) {
    try {
      const result = await fcl.query({
        cadence: `
                pub fun main(address: Address): PublicAccount {
                    let account = getAccount(address)
                    return account
                }
                `,
        args: (arg, t) => [arg(address, t.Address)],
      });
      return result;
    } catch (error) {
      console.log("err", error);
    }
}

export async function getAuthAccount(address) {
    try {
      const result = await fcl.query({
        cadence: `
                pub fun main(address: Address): AuthAccount {
                    let account = getAuthAccount(address)
                    return account
                }
                `,
        args: (arg, t) => [arg(address, t.Address)],
      });
      return result;
    } catch (error) {
      console.log("err", error);
    }
}


export async function iterateOnStoragePaths(address) {
  try {
    const result = await fcl.query({
      cadence: `
              pub fun main(address: Address): [AnyStruct] {
                  let account = getAuthAccount(address)
                  var storagePathsArr : [StoragePath]= []
                  var storageTypesArr : [Type]= []
                  account.forEachStored(fun (path: StoragePath, type: Type): Bool {
                      storagePathsArr.append(path)
                      storageTypesArr.append(type)
                      return true
                  })
                  return [storagePathsArr, storageTypesArr]
              }
              `,
      args: (arg, t) => [arg(address, t.Address)],
    });
    let resultArr = []
    for(let i = 0; i < result[0].length; i++){
      let pathObj = {path: `/${result[0][i].domain}/${result[0][i].identifier}` ,pathObject: result[0][i], type: result[1][i]}
      resultArr.push(pathObj)
    }
    return resultArr;
  } catch (error) {
    console.log("err", error);
  }
}


export async function iterateOnPublicPaths(address) {
  try {
    const result = await fcl.query({
      cadence: `
              pub fun main(address: Address): [AnyStruct] {
                  let account = getAuthAccount(address)
                  var publicPathsArr : [PublicPath]= []
                  var publicTypesArr : [Type]= []
                  account.forEachPublic(fun (path: PublicPath, type: Type): Bool {
                      publicPathsArr.append(path)
                      publicTypesArr.append(type)
                      return true
                  })
                  return [publicPathsArr, publicTypesArr]
              }
              `,
      args: (arg, t) => [arg(address, t.Address)],
    });
    let resultArr = []
    for(let i = 0; i < result[0].length; i++){
      let pathObj = {path: `/${result[0][i].domain}/${result[0][i].identifier}` ,pathObject: result[0][i], type: result[1][i]}
      resultArr.push(pathObj)
    }
    return resultArr;
  } catch (error) {
    console.log("err", error);
  }
}


export async function iterateOnPrivatePaths(address) {
  try {
    const result = await fcl.query({
      cadence: `
              pub fun main(address: Address): [AnyStruct] {
                  let account = getAuthAccount(address)
                  var privatePathsArr : [PrivatePath]= []
                  var privateTypesArr : [Type]= []
                  account.forEachPrivate(fun (path: PrivatePath, type: Type): Bool {
                      privatePathsArr.append(path)
                      privateTypesArr.append(type)
                      return true
                  })
                  return [privatePathsArr, privateTypesArr]
              }
              `,
      args: (arg, t) => [arg(address, t.Address)],
    });
    let resultArr = []
    for(let i = 0; i < result[0].length; i++){
      let pathObj = {path : `/${result[0][i].domain}/${result[0][i].identifier}`, pathObject: result[0][i], type: result[1][i]}
      resultArr.push(pathObj)
    }
    return resultArr;
  } catch (error) {
    console.log("err", error);
  }
}


export async function getCapabilities(address) {
  try {
    let capabilities = {}
    const publicPaths = await iterateOnPublicPaths(address)
    const privatePaths = await iterateOnPrivatePaths(address)

    let publicCapabilities = []
    let totalPublicCapabilities = 0
    let privateCapabilities = []
    let totalPrivateCapabilities = 0

    for(let i = 0; i < publicPaths.length; i++){
      if(publicPaths[i].type.kind == "Capability"){
        publicCapabilities.push(publicPaths[i])
        totalPublicCapabilities++
      }
    }

    for(let i = 0; i < privatePaths.length; i++){
      if(privatePaths[i].type.kind == "Capability"){
        privateCapabilities.push(privatePaths[i])
        totalPrivateCapabilities++
      }
    }

    capabilities["publicCapabilities"] = publicCapabilities
    capabilities["totalPublicCapabilities"] = totalPublicCapabilities
    capabilities["privateCapabilities"] = privateCapabilities
    capabilities["totalPrivateCapabilities"] = totalPrivateCapabilities

    return capabilities;
  } catch (error) {
    console.log("err", error);
  }
}


export async function getChildAccounts(address) {
  try {
    const result = await fcl.query({
      cadence: `
                  import HybridCustody from 0x13f9d5b87b69bbfc

                  pub fun main(parent: Address): [Address] {
                      let acct = getAuthAccount(parent)
                      let manager = acct.borrow<&HybridCustody.Manager>(from: HybridCustody.ManagerStoragePath)
                          ?? panic("manager not found")
                      return  manager.getChildAddresses()
                  }
              `,
      args: (arg, t) => [arg(address, t.Address)],
    });
    return result;
  } catch (error) {
    console.log("err", error);
  }
}

export async function getParentAccounts(address) {
  try {
    const result = await fcl.query({
      cadence: `
                  import HybridCustody from 0x13f9d5b87b69bbfc

                  pub fun main(child: Address): [Address] {
                    let acct = getAuthAccount(child)
                    let o = acct.borrow<&HybridCustody.OwnedAccount>(from: HybridCustody.OwnedAccountStoragePath)
                        ?? panic("owned account not found")
                    return  o.getParentsAddresses() 
                  }
              `,
      args: (arg, t) => [arg(address, t.Address)],
    });
    return result;
  } catch (error) {
    console.log("err", error);
  }
}

export async function getAccountData(address) {


  console.log("Getting Account Data for ", address)
  const pubAccount = await fcl.account(address);
  console.log("pubAccount", pubAccount)
  const authAccount = await getAuthAccount(address);
  console.log("authAccount", authAccount)

  let accountData = {}

  accountData[address] =pubAccount.address
  accountData["balance"] = authAccount.balance
  accountData["availableBalance"] = authAccount.availableBalance
 
  accountData["privatePaths"] = authAccount.privatePaths
  accountData["publicPaths"] = authAccount.publicPaths
  accountData["storagePaths"] = authAccount.storagePaths
  accountData["storageUsed"] = authAccount.storageUsed
  accountData["storageCapacity"] = authAccount.storageCapacity

  accountData["contracts"] = Object.keys(pubAccount.contracts).map(key => {
    return {name: key, code: pubAccount.contracts[key]}
  })

  let activeKeys = []
  let revokedKeys = []
  let totalActiveKeys = 0
  let totalRevokedKeys = 0
  for(let i = 0; i < pubAccount.keys.length; i++){
    if(pubAccount.keys[i].revoked){
      revokedKeys.push(pubAccount.keys[i])
      totalRevokedKeys++
    }else{
      activeKeys.push(pubAccount.keys[i])
      totalActiveKeys++
    }
  }

  accountData["keys"] = {totalKeys:(totalActiveKeys+totalRevokedKeys), totalActiveKeys, totalRevokedKeys,  activeKeys, revokedKeys}

 
  const storagePaths = await iterateOnStoragePaths(address);
  const publicPaths = await iterateOnPublicPaths(address);
  const privatePaths = await iterateOnPrivatePaths(address);
  console.log(storagePaths)
  console.log(publicPaths)
  console.log(privatePaths)

  const childAccounts = await getChildAccounts(address);
  const parentAccounts = await getParentAccounts(address);
  console.log(childAccounts, "childAccounts")
  console.log(parentAccounts, "parentAccounts")
 
  accountData.childAccounts = childAccounts
  accountData.parentAccounts = parentAccounts
  return accountData


}




